/**
 * 离线取单的核对勾选框（契约 §12.2、`05-ui-design-system.md` §6.4 规则 5b、R-02 的缓解措施本体）。
 *
 * **只在离线扫码取单时出现**：联网时服务端是权威，订单码不是唯一凭据。
 *
 * 勾选结果**不在这里**决定请求体的形状 —— 组件只把 `checked` 报给调用方，
 * `verifiedWithCustomer` 这个字段由收款那一条路（`CashierOrderPage`）拼，
 * 而且是**只有离线取单时**才拼。理由：契约 §12.2 的判据是「`origin = "OFFLINE_SCAN"`
 * 且 `verifiedWithCustomer !== true` ⇒ 422 `CUSTOMER_VERIFICATION_REQUIRED`」——
 * 两个字段是**成对**的（静态④ verifygate 判的就是这一对），拆到两个地方各拼一半，
 * 迟早出现「带了勾选却没带来路」这种既过不了服务端、也不该在客户端出现的中间态。
 *
 * `data-testid` 是 `05-ui-design-system.md` §6.8 冻结表**之外**、由计划 §4 五 登记的那一个
 * （`verify-customer-checkbox`，静态⑮ 的 `TESTID_PLAN_EXTRA`）：契约 §6.4 已登记它的存在，
 * 但不在 §6.8 的十行里 —— 别顺手把它挪进那张表。
 */
export function VerifyCustomerCheckbox({
  checked,
  onChange,
}: {
  checked: boolean;
  onChange: (value: boolean) => void;
}) {
  return (
    <label className="flex items-center gap-2 text-sm font-bold">
      <input
        type="checkbox"
        data-testid="verify-customer-checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="h-5 w-5 accent-black"
      />
      已与顾客核对订单
    </label>
  );
}

export default VerifyCustomerCheckbox;
